import { createFileRoute } from "@tanstack/react-router";
import AdminPartsOrderDetail from "@/pages/admin/AdminPartsOrderDetail";

export const Route = createFileRoute("/_adminLayout/admin/parts/orders/$id")({
  component: AdminPartsOrderDetail,
});
